
import { v4 as uuidv4 } from "uuid";
import { 
  PlayerObject, 
  SmartHash
} from "@models/UpsertableBase";
import { 
  Character, 
  CharacterOptions,
  Recipe, 
} from "@dndModels";
import { DataType } from "@dndModels/Types";

export class Campaign extends PlayerObject {
  data_type: DataType = "campaign";
  archived_data_holder: SmartHash = {};

  owner_id = "";
  player_ids: string[] = [];
  character_options: CharacterOptions = new CharacterOptions();
  invites: string[] = [];
  // invites_created: string[] = [];
  reusable_invite = "";
  characters: Character[] = [];
  org_inst_ids: string[] = [];
  veh_inst_ids: string[] = [];
  decks_of_many_things: { id: string, visible: boolean }[] = [];
  is_favorite = false;
  description = "";
  last_updated = 0;

  campaign_recipes_loaded = false;
  campaign_recipes: CampaignRecipe[] = [];

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.owner_id = obj.owner_id ? obj.owner_id : "";
      this.player_ids = obj.player_ids ? obj.player_ids : [];
      if (obj.character_options) {
        this.character_options = new CharacterOptions(obj.character_options);
      } 
      this.invites = obj.invites ? obj.invites : [];
      // this.invites_created = obj.invites_created ? obj.invites_created : [];
      this.reusable_invite = obj.reusable_invite ? obj.reusable_invite : uuidv4().toString();
      this.is_favorite = obj.is_favorite ? obj.is_favorite : false;
      this.org_inst_ids = obj.org_inst_ids ? obj.org_inst_ids : [];
      this.veh_inst_ids = obj.veh_inst_ids ? obj.veh_inst_ids : [];
      this.decks_of_many_things = obj.decks_of_many_things ? obj.decks_of_many_things : [];
      this.description = obj.description ? obj.description : "";
      this.last_updated = obj.last_updated ? obj.last_updated : 0;
    }
    this.player_ids = this.player_ids.filter(o => o !== "");
    this.characters = [];
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      owner_id: this.owner_id,
      player_ids: this.player_ids,
      character_options: this.character_options.toDBObj(),
      invites: this.invites,
      reusable_invite: this.reusable_invite,
      is_favorite: this.is_favorite,
      org_inst_ids: this.org_inst_ids,
      veh_inst_ids: this.veh_inst_ids,
      decks_of_many_things: this.decks_of_many_things,
      description: this.description,
      last_updated: this.last_updated
    };
  }

  generate_invite(): string {
    const invite = uuidv4().toString();
    this.invites.push(invite);
    return invite;
  }

  copy(copyMe: Campaign, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.owner_id = copyMe.owner_id;
    this.player_ids = copyMe.player_ids;
    this.character_options = copyMe.character_options.clone();
    this.invites = copyMe.invites;
    this.reusable_invite = copyMe.reusable_invite;
    this.is_favorite = copyMe.is_favorite;
    this.org_inst_ids = [...copyMe.org_inst_ids];
    this.veh_inst_ids = [...copyMe.veh_inst_ids];
    this.decks_of_many_things = [...copyMe.decks_of_many_things];
    this.characters = copyMe.characters;
    this.description = copyMe.description;
    this.last_updated = copyMe.last_updated;
  }

  clone(drop_ids = false): Campaign {
    const new_obj = new Campaign();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

export class CampaignRecipe extends PlayerObject {
  data_type: DataType = "campaign_recipe";
  for_type: "Item" | "Magic Item Keyword" = "Item";
  campaign_id = "";
  for_id = "";
  recipes: Recipe[] = [];

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.for_type = obj.for_type ? obj.for_type : "Item";
      this.campaign_id = obj.campaign_id ? obj.campaign_id : "";
      this.for_id = obj.for_id ? obj.for_id : "";
      this.recipes = obj.recipes ? obj.recipes.map((o: any) => new Recipe(o)) : [];
    }
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      for_type: this.for_type,
      campaign_id: this.campaign_id,
      for_id: this.for_id,
      recipes: this.recipes.map(o => o.toDBObj())
    };
  }

  copy(copyMe: CampaignRecipe, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.for_type = copyMe.for_type;
    this.campaign_id = copyMe.campaign_id;
    this.for_id = copyMe.for_id;
    this.recipes = copyMe.recipes.map(o => o.clone(drop_ids));
  }

  clone(drop_ids = false): CampaignRecipe {
    const new_obj = new CampaignRecipe();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}